export {};

declare global {
  interface Window {
    Shopify: any;
  }
}

const getRoute = (): string => window.Shopify.routes.root || '/'

export default getRoute